<script>
import {mapState, mapMutations} from 'vuex'

import ModalCloseButton from "@/components/core/ModalCloseButton.vue";
import templatable from "@/mixins/templatable";
import BidPlacedMessage from "@/components/lot-purchased-modal/BidPlacedMessage.vue";
import YourBid from "@/components/lot-purchased-modal/YourBid.vue";
import {getIncrements} from "@/helpers";
import BidIncrement from "@/components/lot-purchased-modal/BidIncrement.vue";
import BidDate from "@/components/lot-purchased-modal/BidDate.vue";
import LotDetails from "@/components/bid-confirmation/LotDetails.vue";
import dynamicFieldsMixin from "@/mixins/dynamicFieldsMixin";

export default {
  name: "LotPurchasedModal",
  components: {ModalCloseButton, BidPlacedMessage, LotDetails, YourBid, BidIncrement, BidDate},
  mixins: [dynamicFieldsMixin, templatable('lotPurchasedModalTemplate')],
  data() {
    return {
      template: `
        <b-modal v-if="lot"
            :id="lotPurchasedModal.id || 'lotPurchasedModal'"
           v-model="lotPurchasedModal.show"
           header-bg-variant="light"
           header-text-variant="dark"
           ok-only
           ok-variant="secondary"
           :ok-title="$t('Close')"
           static
           centered>
          <template #modal-header="{ close }">
            <h5 v-if="lot" class="modal-title"
                v-html="$options.filters.stripTags($options.filters.currentLocale(lot.title))"></h5>
            <ModalCloseButton @click="closeModal()" />
          </template>
          [[template]]
        </b-modal>
      `
    }
  },
  computed: {
    ...mapState(['lotPurchasedModal', 'buyNowExtraData', 'customer']),
    ...mapState({
      lot: state => state.lotPurchasedModal.lot,
      bid: state => state.lotPurchasedModal.bid,
    }),
    increments() {
      return getIncrements(this.lot)
    },
    nextIncrement() {
      const increment = this.increments[0];
      return increment?.increment
    }
  },
  methods: {
    ...mapMutations(['hideLotPurchasedModal']),
    closeModal() {
      this.hideLotPurchasedModal()
    },
  }
}
</script>

<style lang="scss">
  @import "../bootstrap/import";

  .ta-bid-created-modal-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid $gray-200;
  }
</style>
